import { UseEnsAvatarParameters } from 'wagmi'

export const ensAvatarConfig: UseEnsAvatarParameters = {
  assetGatewayUrls: {
    ipfs: 'https://ipfs.euc.li',
  },
}
